<template>
  <v-container id="todos" @click="openDialog">
    <v-text-field
      v-model="task"
      :label="$t('widgets.todo.input')"
      dark
      color="white"
      class="body-2 add-shadow"
      @keydown.enter="create"
    >
      <v-fade-transition slot="append">
        <v-icon v-if="task" @click="create">
          mdi-plus-circle-outline
        </v-icon>
      </v-fade-transition>
    </v-text-field>
    <v-layout v-if="tasks" my-1>
      <strong class="caption">
        <!-- eslint-disable-next-line -->
        {{ $t('widgets.todo.complete') }}: {{ completedTasks }} / {{ tasks.length }}
      </strong>
      <v-spacer></v-spacer>
      <v-progress-circular :value="progress" class="mr-2" size="20">
      </v-progress-circular>
    </v-layout>
    <v-card
      v-if="tasks.length > 0"
      flat
      outlined
      max-height="200"
      :class="tasks.length > 2 ? 'with-overflow' : ''"
    >
      <v-slide-y-transition class="py-0" group tag="v-list">
        <template v-for="(item, i) in tasks">
          <v-list-tile :key="`${i}-${item.text}`">
            <v-list-tile-action class="todo-bump">
              <v-checkbox
                v-model="item.done"
                dark
                color="white lighten-3 add-shadow"
              >
                <div
                  slot="label"
                  :class="(item.done && 'striked') || 'white--text'"
                  class="subtitle-1 add-shadow"
                  v-text="item.text"
                ></div>
              </v-checkbox>
              <v-icon
                dark
                class="dismiss-float add-shadow"
                @click="removeTodo(i)"
              >
                mdi-close-circle
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-slide-y-transition>
    </v-card>
    <v-dialog v-model="dialog" max-width="290" dark>
      <v-card>
        <v-card-title class="subtitle2">
          {{ $t('widgets.peopleInSpace.removeThis') }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text x-small @click="closeDialog()">
            {{ $t('common.buttons.cancel') }}
          </v-btn>

          <v-btn color="red darken-1" text x-small @click="removeWidget()">
            {{ $t('widgets.peopleInSpace.remove') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'Todo',
  props: {
    widgetData: {
      type: Object,
      required: false
    },
    widgetName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tasks: [],
      task: null,
      dialog: false,
      currentWidget: this.$attrs.position
    }
  },
  computed: {
    completedTasks() {
      return this.tasks.filter(task => task.done).length
    },
    progress() {
      return (this.completedTasks / this.tasks.length) * 100
    },
    remainingTasks() {
      return this.tasks.length - this.completedTasks
    }
  },
  watch: {
    // eslint-disable-next-line
    tasks: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.updateTheStore()
      }
    }
  },
  mounted() {
    this.tasks = this.widgetData
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    create() {
      this.tasks.push({
        done: false,
        text: this.task
      })

      this.task = null
    },
    removeTodo(i) {
      this.tasks.splice(i, 1)
    },
    updateTheStore() {
      const updates = ['todo', this.tasks]
      this.$store.dispatch('dashboard/updateWidgetDataFromDialog', {
        updates
      })
    },
    removeWidget() {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.currentWidget]: 'blank'
      })
    }
  }
}
</script>

<style lang="scss">
#todos {
  max-width: 300px;
  .todo-bump {
    .v-input--selection-controls {
      margin-top: 0px;
      padding-top: 10px;
      padding-left: 10px;
      margin-bottom: -14px;
    }
  }
  .theme--dark.v-label {
    color: white !important;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .v-text-field__details {
    display: none !important;
  }
  .v-card {
    background-color: transparent;
    border: 0px;
    box-shadow: none;
    color: white;
  }
  .v-list {
    background-color: transparent;
    color: white;
    &.v-sheet {
      min-height: 90px;
      max-height: 120px;
    }
  }
  .add-shadow {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  }
  .v-label {
    color: white;
  }
  .striked {
    text-decoration: line-through;
    color: white;
  }
  .with-overflow {
    overflow: overlay !important;
  }
  .v-input--checkbox {
    width: 80%;
    float: left;
  }
  .dismiss-float {
    width: 20%;
    float: right;
    padding-top: 10px;
  }
}
</style>

<style lang="scss">
.widget-top {
  &.widget-left {
    #todos {
      float: left;
    }
  }
  &.widget-right {
    #todos {
      float: right;
    }
  }
}
.widget-middle {
  &.widget-left {
    #todos {
      float: left;
    }
  }
  &.widget-right {
    #todos {
      float: right;
    }
  }
}
</style>
